// Plain JS style objects for SourceListTable, applied via the `style` prop.
// No external .css file and no build-time CSS import required — these are
// just objects, so there's nothing that can fail to load.
 
export const iconBtn = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    padding: 0,
    borderRadius: '8px',
    border: '1px solid transparent',
    background: 'transparent',
    cursor: 'pointer',
    transition: 'background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease'
};
 
// Applied on top of iconBtn only while hovered (variant="delete").
export const iconBtnDeleteHover = {
    backgroundColor: '#FBEAEA',
    borderColor: '#F5D6D6',
    color: '#C62828'
};
 
export const accountLink = {
    background: 'none',
    border: 'none',
    padding: 0,
    margin: 0,
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    color: 'var(--eds-misc-brand, #7252BC)',
    fontWeight: 600,
    cursor: 'pointer',
    textAlign: 'left'
};
 
export const accountLinkText = {
    textDecoration: 'underline'
};
 
export const accountArrow = {
    opacity: 0.5,
    transition: 'transform 0.15s ease, opacity 0.15s ease'
};
 
// Applied on top of accountArrow only while the parent link is hovered.
export const accountArrowHover = {
    transform: 'translateX(2px)',
    opacity: 1
};
 
const cellEllipsisBase = {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};
 
export const cellEllipsisName = { ...cellEllipsisBase, maxWidth: '130px' };
export const cellEllipsisBucket = { ...cellEllipsisBase, maxWidth: '150px' };
export const cellEllipsisPrefix = { ...cellEllipsisBase, maxWidth: '120px' };
 
export const actionCell = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '6px',
    width: 'fit-content',
    paddingRight: '2px'
};
 
export const actionIconWrap = {
    display: 'inline-flex'
};
 
export const sourcePanel = {
    padding: '24px 24px 16px 24px',
    display: 'flex',
    flexDirection: 'column'
};
 
export const sourceHeader = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    flex: '0 0 auto',
    minHeight: 0
};
 
export const sourceSearchWrap = {
    width: '320px',
    maxWidth: '100%',
    flexShrink: 0
};
 
export const noContract = {
    marginTop: '16px',
    color: 'var(--eds-body-text-color, #525457)'
};
 
export const loadingMessage = {
    marginTop: '16px'
};
 
export const errorMessage = {
    marginTop: '16px',
    color: 'var(--eds-form-error-text, #DF4661)'
};
 
export const gridWrap = {
    paddingLeft: '12px',
    paddingRight: '12px',
    backgroundColor: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '16px',
    boxShadow: '0 1px 2px rgba(16, 24, 40, 0.04), 0 6px 18px rgba(16, 24, 40, 0.06)',
    overflow: 'hidden'
};
 
export const gridEmpty = {
    padding: '12px 8px',
    color: 'var(--eds-body-text-color, #525457)'
};
 
export const pagination = {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    alignItems: 'center',
    marginTop: '2px',
    marginBottom: '0',
    padding: '16px',
    gap: '12px',
    flex: '0 0 auto'
};
 
export const paginationInfo = {
    color: 'var(--eds-body-text-color, #525457)',
    fontSize: '13px',
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
};
 
export const paginationActions = {
    display: 'grid',
    gridAutoFlow: 'column',
    gridAutoColumns: 'max-content',
    gap: '8px',
    justifySelf: 'end'
};